if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        // Handle case where form tag is missing (Shopify rendering bug)
        if (!this.form) {
          const submitButton = this.querySelector('[type="submit"]');
          const idInput = this.querySelector('[name="id"]');

          if (submitButton && idInput) {
            idInput.disabled = false;

            // Create a wrapper form element and move children into it
            const formElement = document.createElement('form');
            formElement.method = 'post';
            formElement.action = '/cart/add';
            formElement.setAttribute('enctype', 'multipart/form-data');
            formElement.setAttribute('novalidate', 'novalidate');
            formElement.setAttribute('data-type', 'add-to-cart-form');
            formElement.classList.add('form');

            // Move all children into the form
            while (this.firstChild) {
              formElement.appendChild(this.firstChild);
            }

            this.appendChild(formElement);
            this.form = formElement;
          }
        }

        if (this.form) {
          this.formName = this.form.querySelector('[name=id]')
          if (this.formName) {
            this.formName.disabled = false;
          }
          this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          this.submitButton = this.querySelector('[type="submit"]');
          if (this.submitButton) {
            if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }

          this.hideErrors = this.dataset.hideErrors === 'true';
        }
      }

      onSubmitHandler(evt) {

        console.log('event add to cart:', evt)

        // bundle builder logic
         evt.preventDefault();
        if (!this.submitButton) return;
        // Check for back-in-stock BEFORE disabling buttons
        if (this.submitButton.classList.contains('js-back-in-stock')) return;
        let addedFromBundleBuilder = false;
        let isFreeProductOnBundlePage = false;

        if (evt.target.closest('.bundle-builder__add-to-bundle')) {
          addedFromBundleBuilder = true;

          //disable all other buttons
          document.querySelectorAll('.bundle-builder__collections.show .quick-add__submit').forEach(el => {
            el.classList.add('disabled_btn')
            // console.log('element dat disable', el)
          })
        }

        // Check if adding free product on bundle page
        const isFreeProduct = this.form.querySelector('[name="properties[_dsrFree]"]')?.value === 'true';
        const isOnBundlePage = document.querySelector('.bundle-builder__wrapper') !== null;
        if (isFreeProduct && isOnBundlePage) {
          isFreeProductOnBundlePage = true;
        }

        // END bundle builder logic

        evt.preventDefault();
        if (!this.submitButton) return; //exit function if we don't have a submit button

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        if (document.cookie.indexOf('hiddenSale=true') !== -1) {
          formData.append('attributes[dsrDiscounts]', 'true');
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (addedFromBundleBuilder) {
                //bundle builder logic

                console.log('added from bundle builder!!!')

                let oldText = evt.submitter.dataset.btnText
                evt.submitter.querySelector('span').innerHTML = `ADDED`
                evt.submitter.classList.add('bundle-item-added')

                setTimeout(() => {
                  evt.submitter.querySelector('span').innerHTML = oldText;
                  evt.submitter.classList.remove('bundle-item-added');

                  this.cart.renderContents(response, addedFromBundleBuilder);

                }, 1000)

                updateBundleBuilder();

                // END bundle builder logic
              }
              else {
                this.cart.renderContents(response, isFreeProductOnBundlePage, [this.form.querySelector("[name=product-id]").value]);
              }

              // Change button to "ADDED" state
              if (this.submitButton && !addedFromBundleBuilder) {
                // Find the visible span (not the sr-only one)
                const spans = this.submitButton.querySelectorAll('span');
                let buttonSpan = null;
                if (spans.length > 0) {
                  buttonSpan = Array.from(spans).find(span => !span.classList.contains('sr-only'));
                  if (!buttonSpan) {
                    buttonSpan = spans[0];
                  }
                }

                const originalText = buttonSpan ? buttonSpan.innerHTML : '';
                const originalColor = this.submitButton.style.color;
                const originalBackgroundColor = this.submitButton.style.backgroundColor;

                this.submitButton.style.color = '#fff';
                this.submitButton.style.backgroundColor = 'rgba(239, 119, 106, 1)';
                this.submitButton.classList.add('is-added-state');

                if (buttonSpan) {
                  buttonSpan.innerHTML = `<div class="added-to-cart-button"><svg width="16" height="16" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.9963 12.3558C23.9963 18.7847 18.7847 23.9963 12.3558 23.9963C5.92697 23.9963 0.715332 18.7847 0.715332 12.3558C0.715332 5.92697 5.92697 0.715332 12.3558 0.715332C18.7847 0.715332 23.9963 5.92697 23.9963 12.3558Z" stroke="white" stroke-width="1.43081"/>
<path d="M7.50586 12.1189L11.0498 15.6628L17.2668 9.4458" stroke="white" stroke-width="1.43081"/>
</svg>ADDED</div>`;
                  this.submitButton.style.pointerEvents = 'none';

                  // Revert after 4 seconds
                  setTimeout(() => {
                    buttonSpan.innerHTML = originalText;
                    this.submitButton.style.pointerEvents = '';
                    this.submitButton.style.color = originalColor;
                    this.submitButton.style.backgroundColor = originalBackgroundColor;
                    this.submitButton.classList.remove('is-added-state');

                    // Check if cart limit is reached and update button accordingly
                    if (typeof cartLimitReached === 'function') {
                      cartLimitReached();
                    }
                  }, 4000);
                }
              }

              return response
            }
          })
          .then((response) => {
            klaviyoAddedToCart(response, this.dataset.retailPrice); //used to send cart data to klaviyo after atc
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');

            // Update add to cart buttons if the cart limit is reached
            setTimeout(() => {
              cartLimitReached();

              if (addedFromBundleBuilder) {
                //reenable btns
                document.querySelectorAll('.bundle-builder__collections.show .quick-add__submit').forEach(el => {
                  el.classList.remove('disabled_btn')
                  // console.log('element dat disable', el)
                })
              }
            }, 1500);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
